var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        { attrs: { inline: false, "label-position": "top", size: "small" } },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 7 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "timeType" } },
                    [
                      _c("template", { slot: "label" }, [
                        _c(
                          "div",
                          { staticClass: "selectLabel" },
                          [
                            _c(
                              "el-select",
                              {
                                style: _vm.IsWidth,
                                model: {
                                  value: _vm.queryForm.params.timeType,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryForm.params,
                                      "timeType",
                                      $$v
                                    )
                                  },
                                  expression: "queryForm.params.timeType",
                                },
                              },
                              [
                                _c("el-option", {
                                  key: "1",
                                  attrs: {
                                    label: _vm.$t("GlobalSetObj.CreationTime"),
                                    value: 1,
                                  },
                                }),
                                _c("el-option", {
                                  key: "2",
                                  attrs: {
                                    label: _vm.$t(
                                      "customerManagements.genterTiem"
                                    ),
                                    value: 2,
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          clearable: false,
                          "default-time": ["00:00:00", "23:59:59"],
                          "end-placeholder": _vm.$t("GlobalSetObj.endDate"),
                          format:
                            _vm.$i18n.locale == "zh" ? _vm.zhDate : _vm.ptDate,
                          "start-placeholder": _vm.$t("GlobalSetObj.startDate"),
                          "range-separator": "~",
                          type: "datetimerange",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                        },
                        model: {
                          value: _vm.timeValue,
                          callback: function ($$v) {
                            _vm.timeValue = $$v
                          },
                          expression: "timeValue",
                        },
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("orderCenterCont.CustomerName") },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t(
                              "GlobalSetObj.OnlyAreDisplayed"
                            ),
                            "remote-method": _vm.searchGetUserList,
                            clearable: "",
                            filterable: "",
                            remote: "",
                            "reserve-keyword": "",
                          },
                          on: {
                            change: _vm.searchGetUserListFocus2,
                            focus: _vm.searchGetUserListFocus1,
                          },
                          model: {
                            value: _vm.queryForm.params.customerId,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm.params, "customerId", $$v)
                            },
                            expression: "queryForm.params.customerId",
                          },
                        },
                        _vm._l(_vm.userList, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.username, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("collectionCenter.CommercialOwner"),
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                            "remote-method": _vm.getapiCustomerPageList,
                            clearable: "",
                            filterable: "",
                            remote: "",
                            "reserve-keyword": "",
                          },
                          on: {
                            change: _vm.searchgetapiCustomerPageList,
                            focus: _vm.searchgetapiCustomerPageList1,
                          },
                          model: {
                            value: _vm.queryForm.params.merchantId,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm.params, "merchantId", $$v)
                            },
                            expression: "queryForm.params.merchantId",
                          },
                        },
                        _vm._l(_vm.customerMerchant, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label:
                                item.merchantName +
                                "（" +
                                item.merchantCode +
                                "）",
                              value: item.id,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("customerManagements.TimeType") },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                          },
                          model: {
                            value: _vm.queryForm.params.ageingType,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm.params, "ageingType", $$v)
                            },
                            expression: "queryForm.params.ageingType",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("GlobalSetObj.all"),
                              value: null,
                            },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t(
                                "customerManagements.CustomerDeliveryTime"
                              ),
                              value: 0,
                            },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t(
                                "customerManagements.CustomerClosedLoop"
                              ),
                              value: 1,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("GlobalSetObj.status") } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                          },
                          model: {
                            value: _vm.queryForm.params.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm.params, "status", $$v)
                            },
                            expression: "queryForm.params.status",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("GlobalSetObj.all"),
                              value: null,
                            },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("GlobalSetObj.enable"),
                              value: 1,
                            },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("GlobalSetObj.stop"),
                              value: 0,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 15 } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        icon: "el-icon-search",
                        size: "small",
                        type: "primary",
                      },
                      on: { click: _vm.enterSearch },
                    },
                    [_vm._v(_vm._s(_vm.$t("newOrder.search")) + " ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        icon: "el-icon-refresh-left",
                        size: "small",
                        type: "info",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.resetForm()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("newOrder.reset")) + " ")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-bottom": "15px" },
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.addCusTime },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("customerManagements.newCusTime")) + " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            "header-cell-style": { background: "#f2f2f2", color: "black" },
            border: "",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("GlobalSetObj.serial"),
              align: "center",
              type: "index",
              width: "70",
            },
          }),
          _vm._l(_vm.tableHeaderList, function (item) {
            return _c("el-table-column", {
              key: item.id,
              attrs: {
                label: item.label,
                "min-width": item.cloWidth,
                prop: item.prop,
                "show-overflow-tooltip": false,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        item.prop === "merchantName" &&
                        scope.row.merchantName &&
                        scope.row.merchantCode
                          ? _c("div", [
                              _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(scope.row.merchantName) +
                                    "（" +
                                    _vm._s(scope.row.merchantCode) +
                                    "） "
                                ),
                              ]),
                            ])
                          : item.prop === "statusTypeObjName"
                          ? _c(
                              "div",
                              [
                                scope.row.status === 0
                                  ? _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          effect: "dark",
                                          size: "small",
                                          type: "danger",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(scope.row.statusTypeObjName) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          effect: "dark",
                                          size: "small",
                                          type: "",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(scope.row.statusTypeObjName) +
                                            " "
                                        ),
                                      ]
                                    ),
                              ],
                              1
                            )
                          : item.prop === "calculatedDay"
                          ? _c("div", [
                              _c(
                                "div",
                                { staticStyle: { "line-height": "30px" } },
                                _vm._l(
                                  scope.row.calculatedDayList1,
                                  function (item1, index) {
                                    return _c(
                                      "el-tag",
                                      {
                                        key: index,
                                        staticStyle: { "margin-right": "5px" },
                                        attrs: {
                                          type:
                                            "" +
                                            (scope.row.calculatedDayList[
                                              index
                                            ] > 5
                                              ? "danger"
                                              : ""),
                                          effect: "dark",
                                          size: "small",
                                        },
                                      },
                                      [_vm._v(" " + _vm._s(item1) + " ")]
                                    )
                                  }
                                ),
                                1
                              ),
                            ])
                          : item.prop === "ageingType"
                          ? _c(
                              "div",
                              [
                                scope.row.ageingType === 0
                                  ? _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          effect: "dark",
                                          size: "small",
                                          type: "primary",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "customerManagements.CustomerDeliveryTime"
                                            )
                                          ) + " "
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          effect: "dark",
                                          size: "small",
                                          type: "success",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "customerManagements.CustomerClosedLoop"
                                            )
                                          ) + " "
                                        ),
                                      ]
                                    ),
                              ],
                              1
                            )
                          : _c("div", [
                              _vm._v(
                                _vm._s(
                                  scope.row[item.prop]
                                    ? "" + scope.row[item.prop]
                                    : "- -"
                                )
                              ),
                            ]),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            })
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("newOrder.operation"),
              align: "center",
              fixed: "right",
              width: "120",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between",
                          "align-items": "center",
                        },
                      },
                      [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              content: _vm.$t(
                                "customerManagements.downloadTimeTable"
                              ),
                              effect: "dark",
                              placement: "top",
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-download textOperator",
                              on: {
                                click: function ($event) {
                                  return _vm.downloadOrder(scope.row)
                                },
                              },
                            }),
                          ]
                        ),
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              content: _vm.$t("GlobalSetObj.edit"),
                              effect: "dark",
                              placement: "top",
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-edit textOperator",
                              on: {
                                click: function ($event) {
                                  return _vm.editMessage(scope.row)
                                },
                              },
                            }),
                          ]
                        ),
                        scope.row.status === 0
                          ? _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  content: _vm.$t("GlobalSetObj.enable"),
                                  effect: "dark",
                                  placement: "top",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "el-icon-circle-check textOperator",
                                  on: {
                                    click: function ($event) {
                                      return _vm.updateStatus(scope.row)
                                    },
                                  },
                                }),
                              ]
                            )
                          : _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  content: _vm.$t("GlobalSetObj.stop"),
                                  effect: "dark",
                                  placement: "top",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "el-icon-remove-outline textOperator1",
                                  on: {
                                    click: function ($event) {
                                      return _vm.updateStatus(scope.row)
                                    },
                                  },
                                }),
                              ]
                            ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        2
      ),
      _c("el-pagination", {
        staticStyle: { margin: "10px 0", float: "right" },
        attrs: {
          "current-page": _vm.queryForm.pageNumber,
          "page-size": _vm.queryForm.pageSize,
          "page-sizes": [10, 20, 50, 100],
          total: _vm.queryForm.total,
          background: "",
          layout: "total, sizes, prev, pager, next, jumper",
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            title: _vm.cusTimeDialogTitle,
            visible: _vm.addCusTimeDialog,
            width: "550px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.addCusTimeDialog = $event
            },
            close: _vm.handleAddCusTimeDialog,
          },
        },
        [
          _c(
            "el-form",
            {
              key: _vm.addCusTimeDialog,
              ref: "ruleForm",
              staticClass: "demo-ruleForm",
              attrs: {
                model: _vm.ruleForm,
                rules: _vm.rules,
                "label-width": "auto",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("customerManagements.selectCus"),
                    prop: "customerId",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        placeholder: _vm.$t("GlobalSetObj.OnlyAreDisplayed"),
                        "remote-method": _vm.searchGetUserList,
                        clearable: "",
                        filterable: "",
                        remote: "",
                        "reserve-keyword": "",
                      },
                      on: {
                        change: _vm.searchGetUserListFocus,
                        focus: _vm.searchGetUserListFocus1,
                      },
                      model: {
                        value: _vm.ruleForm.customerId,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "customerId", $$v)
                        },
                        expression: "ruleForm.customerId",
                      },
                    },
                    _vm._l(_vm.userList, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label: item.username,
                          value: item.id + "~" + item.username,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm.isSelect
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("collectionCenter.CommercialOwner"),
                        prop: "merchantId",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { overflow: "hidden" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.OnlyAreDisplayed"
                                ),
                                "remote-method": _vm.serchMerchantIdList,
                                clearable: "",
                                filterable: "",
                                remote: "",
                                "reserve-keyword": "",
                              },
                              on: {
                                change: _vm.serchMerchantIdList1,
                                focus: _vm.serchMerchantIdList2,
                              },
                              model: {
                                value: _vm.ruleForm.merchantId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "merchantId", $$v)
                                },
                                expression: "ruleForm.merchantId",
                              },
                            },
                            _vm._l(_vm.merchantIdList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label:
                                    item.merchantName +
                                    "（" +
                                    item.merchantCode +
                                    "）",
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("customerManagements.TimeType"),
                    prop: "ageingType",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                      },
                      model: {
                        value: _vm.ruleForm.ageingType,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "ageingType", $$v)
                        },
                        expression: "ruleForm.ageingType",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t(
                            "customerManagements.CustomerDeliveryTime"
                          ),
                          value: 0,
                        },
                      }),
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t(
                            "customerManagements.CustomerClosedLoop"
                          ),
                          value: 1,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("customerManagements.timeCalcuDay"),
                    prop: "calculatedDay",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                        multiple: "",
                      },
                      model: {
                        value: _vm.ruleForm.calculatedDay,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "calculatedDay", $$v)
                        },
                        expression: "ruleForm.calculatedDay",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t("customerManagements.weekOne"),
                          value: "1",
                        },
                      }),
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t("customerManagements.weekTwo"),
                          value: "2",
                        },
                      }),
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t("customerManagements.weekThree"),
                          value: "3",
                        },
                      }),
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t("customerManagements.weekFoure"),
                          value: "4",
                        },
                      }),
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t("customerManagements.weekFirtFive"),
                          value: "5",
                        },
                      }),
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t("customerManagements.weekSix"),
                          value: "6",
                        },
                      }),
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t("customerManagements.weekSeven"),
                          value: "7",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("customerManagements.genterTiem"),
                    prop: "effectiveTime",
                  },
                },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      "default-time": _vm.defaultTime,
                      "picker-options": _vm.pickerOptions,
                      placeholder: _vm.$t("newOrder.SelectDatetime"),
                      type: "datetime",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                    },
                    model: {
                      value: _vm.ruleForm.effectiveTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "effectiveTime", $$v)
                      },
                      expression: "ruleForm.effectiveTime",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("customerManagements.agingType"),
                    prop: "agingType",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      model: {
                        value: _vm.ruleForm.agingType,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "agingType", $$v)
                        },
                        expression: "ruleForm.agingType",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t("customerManagements.anDay"),
                          value: 0,
                        },
                      }),
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t("customerManagements.anTime"),
                          value: 1,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t(
                      "customerManagements.timeframeStartingPointName"
                    ),
                    prop: "timeframeStartingPoint",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                      },
                      model: {
                        value: _vm.ruleForm.timeframeStartingPoint,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "timeframeStartingPoint", $$v)
                        },
                        expression: "ruleForm.timeframeStartingPoint",
                      },
                    },
                    _vm._l(_vm.startLabel, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm.cusTimeDialogTitle !==
              _vm.$t("customerManagements.editCusTime")
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "" } },
                    [
                      _c(
                        "template",
                        { slot: "label" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small", type: "primary" },
                              on: { click: _vm.triggerFileInput },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("customerManagements.clickUpload")
                                ) + " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c("input", {
                        ref: "referenceUpload",
                        staticStyle: { display: "none" },
                        attrs: {
                          accept:
                            ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
                          type: "file",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.uploadFile($event)
                          },
                        },
                      }),
                      _c("div", {}, [
                        _c(
                          "span",
                          {
                            staticClass: "downModule",
                            on: { click: _vm.downLoadFile },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("orderCenterCont.DownloadTemplate"))
                            ),
                          ]
                        ),
                        _c(
                          "span",
                          {
                            staticStyle: { "font-size": "12px", color: "red" },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("customerManagements.pleaseUploadLI")
                              )
                            ),
                          ]
                        ),
                      ]),
                    ],
                    2
                  )
                : _vm._e(),
              _vm.fileName
                ? _c("div", { staticClass: "downLink" }, [
                    _c("div", [_vm._v(_vm._s(_vm.fileName))]),
                    _vm.cusTimeDialogTitle !==
                    _vm.$t("customerManagements.editCusTime")
                      ? _c("div", [
                          _c("i", {
                            staticClass: "el-icon-error",
                            on: { click: _vm.delFile },
                          }),
                        ])
                      : _vm._e(),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.cusSubmit(1)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("GlobalSetObj.cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.cusSubmit(2)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("GlobalSetObj.confirm")) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }